import { BONDS_SUBGRAPH_URL } from '@sushiswap/bonds-sdk';
import { addChainId } from '../../../lib/modifiers/add-chain-id';
import { convertIdToMultichainId } from '../../../lib/modifiers/convert-id-to-multichain-id';
import { copyIdToAddress } from '../../../lib/modifiers/copy-id-to-address';
import { requestPaged } from '../../../lib/request-paged';
import { graphql } from '../graphql';
export const BondUserPositionsQuery = graphql(`
  query UserPositions($first: Int = 1000, $skip: Int = 0, $block: Block_height, $orderBy: OwnerBalance_orderBy, $orderDirection: OrderDirection, $where: OwnerBalance_filter) {
    ownerBalances(first: $first, skip: $skip, block: $block, orderBy: $orderBy, orderDirection: $orderDirection, where: $where) {
      id
      owner
      balance
      bondToken {
        id
        expiry
        type
        teller
        underlying {
          id: address
          symbol
          decimals
          name
        }
      }
    }
  }
`);
export async function getBondUserPositions({ chainId, ...variables }, options) {
    const url = `https://${BONDS_SUBGRAPH_URL[chainId]}`;
    const result = await requestPaged({
        chainId,
        url,
        query: BondUserPositionsQuery,
        variables,
        options,
    });
    return result.ownerBalances.map((position) => {
        const bondTokenUnderlying = position.bondToken
            ? convertIdToMultichainId(copyIdToAddress(addChainId(chainId, position.bondToken
                .underlying)))
            : null;
        return addChainId(chainId, {
            ...position,
            bondToken: {
                ...position.bondToken,
                underlying: bondTokenUnderlying,
            },
        });
    });
}
